import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import Header from "./components/Header/Header.jsx";
import ProductsPage from "./pages/Product/ProductsPage.jsx";
import ProductPage from "./pages/Product/ProductPage.jsx";
import SuccessOrder from "./components/Result/SuccessOrder.jsx";
import SearchResults from "./components/Search/SearchResults.jsx";
import HomePage from "./pages/Home/HomePage.jsx";
import ConsentNoticeNotification from "./components/Notification/ConsentNotice.jsx";
import OrderPage from "./pages/Order/OrderPage.jsx";

function AppRoutes() {

    // Sometimes site does not show anything on android and ios devices,
    // so this effect is worked properly for some reason
    const agentTimeout = () => {
        const userAgent = navigator.userAgent || "";

        if (userAgent.includes("Android")) {
            setTimeout(() => {
                //
            }, 1000);
        } else {
            //
        }
    };

    useEffect(() => {
        try {
            agentTimeout();

            const userAgent = navigator.userAgent || "";

            if (userAgent.includes("iPhone")) {
                window.disableWebkitEnterFullscreen = function () {
                    //
                };
            }
        } catch (error) {
            if (error.message.includes("Method not found")) {
                //
            } else {
                //
            }
        }
    }, []);

    return (
        <div>
            <div>
                <ConsentNoticeNotification/>
                    <Header />
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/products/:category/:subcategory1?/:subcategory2?" element={<ProductsPage />} />
                        <Route path="/product/:productid" element={<ProductPage />} />
                        <Route path="/order" element={<OrderPage />} />
                        <Route path="/purchased" element={<SuccessOrder />} />
                        <Route path="/search" element={<SearchResults />} />
                    </Routes>
            </div>
        </div>
    );
}

export default AppRoutes;